module.exports = __webpack_public_path__ + "img/armenia.3f177416.svg";